module.exports = __webpack_public_path__ + "img/14.9867e086.jpg";